import { useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Sparkles, CalendarRange, Infinity as InfinityIcon } from "lucide-react";
import { RankRow, useTopShared } from "@/components/TopShared";

const PERIODS = [
  { id: "all", label: "Di sempre", icon: InfinityIcon },
  { id: "week", label: "Questa settimana", icon: CalendarRange },
];

const PeriodTabs = ({ period, setPeriod }) => (
  <div className="inline-flex rounded-full border border-white/10 bg-[#12141F] p-1" data-testid="leaderboard-period-tabs">
    {PERIODS.map(({ id, label, icon: Icon }) => (
      <button key={id} onClick={() => setPeriod(id)} data-testid={`leaderboard-tab-${id}`} aria-pressed={period === id}
        className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-200 ${period === id ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:text-slate-100"}`}>
        <Icon className="w-4 h-4" /> {label}
      </button>
    ))}
  </div>
);

export default function Leaderboard() {
  const [period, setPeriod] = useState("all");
  const items = useTopShared(50, period);
  const weekly = period === "week";
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-10" data-testid="leaderboard-page">
      <div className="flex items-center gap-2 overline-label"><Trophy className="w-4 h-4" /> Classifica pubblica</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-4 leading-[1.05]">Le idee più viste dalla community.</h1>
      <p className="text-slate-400 mt-5 max-w-2xl leading-relaxed">La classifica premia i "Mi piace" della community, poi le visualizzazioni. Vota le idee che ti convincono, salva quelle che ti piacciono o genera le tue.</p>
      <div className="mt-10"><PeriodTabs period={period} setPeriod={setPeriod} /></div>
      <div className="mt-8 space-y-3">
        {items === null && <p className="text-slate-400" data-testid="leaderboard-loading">Caricamento…</p>}
        {items && items.length === 0 && (
          <div className="rounded-3xl border border-white/[0.07] bg-[#12141F] p-10 text-center" data-testid="leaderboard-empty">
            <p className="text-slate-300">{weekly ? "Nessun voto negli ultimi 7 giorni. Vota un'idea e falla salire!" : "Nessuna idea condivisa per ora. Sii il primo!"}</p>
          </div>
        )}
        {items && items.map((it, i) => <RankRow key={it.share_id} item={it} rank={i + 1} weekly={weekly} />)}
      </div>
      <div className="mt-14 rounded-3xl border border-amber-500/30 bg-gradient-to-br from-amber-500/[0.1] to-transparent p-8 sm:p-10 flex flex-wrap items-center justify-between gap-6">
        <div>
          <h2 className="font-display text-xl md:text-2xl font-bold">Vuoi la tua idea in classifica?</h2>
          <p className="text-slate-400 mt-2 text-sm">Genera un'idea, condividila su WhatsApp o LinkedIn e guarda le visualizzazioni salire.</p>
        </div>
        <Link to="/genera" data-testid="leaderboard-cta-btn" className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-7 py-3.5 font-semibold text-slate-950 hover:bg-amber-400 transition-colors"><Sparkles className="w-4 h-4" /> Genera le mie idee</Link>
      </div>
    </div>
  );
}
